import styled from "styled-components"
import { TABLET_MAX_WIDTH, MOBILE_MIN_WIDTH } from "@constants"
import { Link } from "gatsby"

export const StyledBlogArticleWrapper = styled.div`
  gap: 44px;
  max-width: 90vw;
  margin-bottom: 30px;
  display: grid;
  grid-template-columns: 1fr 4fr;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    gap: 0;
    grid-template-columns: 1fr;
  }
`

export const StyledArticleImageContainer = styled.div`
  height: 100%;
`

export const StyledArticleImage = styled.img`
  height: 238px;
  width: 417px;
  object-fit: cover;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    height: 325px;
    width: 100%;
  }

  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
    height: 238px;
  }
`

export const StyledArticleContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: stretch;

  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
    max-width: 90vw;
  }
`

export const StyledArticleReadingInformation = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  letter-spacing: 0.8px;
`

export const StyledArticleDomain = styled.p`
  margin: 0;
  color: rgba(37, 37, 37, 0.8);
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.8px;
`

export const StyledSlash = styled.p`
  margin: 0;
  color: rgba(196, 177, 128, 0.3);
`

export const StyledArticleReadingTime = styled.p`
  margin: 0;
  color: rgba(37, 37, 37, 0.8);
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.8px;
`

export const StyledArticleTitleContainer = styled.div`
  color: #252525;
  font-weight: 700;
  letter-spacing: 0.56px;
`

export const StyledArticleTitle = styled.h2`
  color: #252525;
  font-size: 28px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0.56px;
  margin: 0;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    font-size: 24px;
    letter-spacing: 0.48px;
    margin: 10px 0;
  }

  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
    color: rgba(37, 37, 37, 0.8);
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0.4px;
  }
`

export const StyledArticleDescriptionContainer = styled.div`
  margin-bottom: 16px;
`

export const StyledArticleDescription = styled.p`
  margin: 0;
  color: rgba(37, 37, 37, 0.8);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.8px;
`

export const StyledAboutArticleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(37, 37, 37, 0.8);

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    flex-wrap: wrap;
  }
`

export const StyledArticleAuthorImage = styled.img`
  height: 24px;
  width: 24px;
  border-radius: 100px;
  object-fit: cover;
  margin: 0;
`

export const StyledArticleAuthorName = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.8px;
  margin: 0;
`

export const StyledArticleCreationDate = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.8px;
  margin: 0;
`

export const StyledArticleLink = styled(Link)`
  text-decoration: none;
  color: #252525;
`
